const busquedaEncontrada = {
  'No encontramos lo que estás buscando': 'No encontramos lo que estás buscando',
  'Prueba con otras palabras o asegúrate de que estén bien escritas':
    'Prueba con otras palabras o asegúrate de que estén bien escritas.',
}

export default busquedaEncontrada
